module.exports = __webpack_public_path__ + "img/ico_pick.a79082e5.svg";